import TnCContent from './TnCContent'
export default TnCContent
